// extracted by mini-css-extract-plugin
module.exports = {"comp":"I_comp__AM_Tm"};